import {createSelector} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';

import {AIS3_SLICE} from '../ais-slice-constants';

const selectAisSliceState = (state: TAppState) => state[AIS3_SLICE];

export const selectNotificationScenariosSettingsTableData = createSelector(
    selectAisSliceState,
    ({aisNotificationScenariosSettings}) => ({
        notificationScenariosSettingsTable: aisNotificationScenariosSettings.notificationScenariosTable,
        recordsTotal: aisNotificationScenariosSettings.recordsTotal,
    }),
);

export const selectNotificationScenariosSettingsServices = createSelector(
    selectAisSliceState,
    ({aisNotificationScenariosSettings}) => aisNotificationScenariosSettings.notificationScenariosServices,
);
